import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import Helper from "util/Helper";

export class CreateServiceUtil {
  constructor() {
    this.apiService = new APIService();
    this.helper = new Helper();
  }

  getServiceType(body, onResponse, onError) {
    let url = APIConfig.myPlan.createService.getServiceType.format(body);
    return this.apiService.get(url, onResponse, onError);
  }
  getServicesByFilter(body, onResponse, onError) {
    let url = APIConfig.myPlan.serviceDashboard.fetchServicesByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getAssignedServiceProvidersByFilter(body, onResponse, onError) {
    let url =
      APIConfig.myPlan.assignServiceProvider
        .getAssignedServiceProvidersByFilter;
    return this.apiService.post(url, body, onResponse, onError);
  }
  getMarginData(onResponse, onError) {
    let url = APIConfig.myPlan.assignServiceProvider.getMarginData;
    return this.apiService.get(url, onResponse, onError);
  }
  getMarginColor(onResponse, onError) {
    let url = APIConfig.myPlan.assignServiceProvider.getMarginColor;
    return this.apiService.get(url, onResponse, onError);
  }
  getServiceSubType(id, status, onResponse, onError) {
    let url = APIConfig.myPlan.createService.getServiceSubType.format(
      id,
      status
    );

    return this.apiService.get(url, onResponse, onError);
  }
  //upload  image
  uploadImg = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.uploadContent;
    return this.apiService.postWithFormData(url, body, onResponse, onError);
  };
  uploadAgreementDoc = (body, onResponse, onError) => {
    let url = APIConfig.navigoDashboard.uploadContentV4;
    return this.apiService.postWithFormData(url, body, onResponse, onError);
  };
  createService(body, onResponse, onError) {
    let url = APIConfig.myPlan.createService.createNewService;
    return this.apiService.post(url, body, onResponse, onError);
  }
  updateService(id, body, onResponse, onError) {
    let url = APIConfig.myPlan.createService.updateService.format(id);
    return this.apiService.put(url, body, onResponse, onError);
  }
  getServiceById(id, onResponse, onError) {
    let url = APIConfig.myPlan.createService.getServiceById.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getServiceProviderById(id, onResponse, onError) {
    let url = APIConfig.myPlan.serviceProvider.getById.format(id);
    return this.apiService.get(url, onResponse, onError);
  }

  getAllPlans(payload, onResponse, onError) {
    let url = APIConfig.myPlan.serviceProvider.getAllPlans;
    return this.apiService.post(url, payload, onResponse, onError);
  }
  saveServiceProviderAvailability(payload, onResponse, onError) {
    let url = APIConfig.myPlan.serviceProvider.saveServiceProviderAvailability;
    return this.apiService.post(url, payload, onResponse, onError);
  }
  updateServiceProviderAvailability(payload, onResponse, onError) {
    let url =
      APIConfig.myPlan.serviceProvider.updateServiceProviderAvailability;
    return this.apiService.put(url, payload, onResponse, onError);
  }
  getAllData(id, onResponse, onError) {
    let url = APIConfig.myPlan.serviceProvider.getAllData.format(id);
    return this.apiService.get(url, onResponse, onError);
  }
  getCalendar(payload, onResponse, onError) {
    let url = APIConfig.myPlan.serviceProvider.getCalendar;
    return this.apiService.post(url, payload, onResponse, onError);
  }

  getDiagnosticTestsByFilter(payload, onResponse, onError) {
    let url = APIConfig.myPlan.createService.getDiagnosticTestsByFilter;
    return this.apiService.post(url, payload, onResponse, onError);
  }

  // getDoseSchedule(data, onResponse, onError) {
  //   let url = `${APIConfig.doseScheduleApis.getDoseSchedule}?pid=${data}`;
  //   return this.apiService.get(url, onResponse, onError);
  // }

  // updateDoseSchedule(body, onResponse, onError) {
  //   let url = APIConfig.doseScheduleApis.updateDoseSchedule;
  //   return this.apiService.put(url, body, onResponse, onError);
  // }
  // createProgressNote(body, onResponse, onError) {
  //   let url = APIConfig.progressNote.new;
  //   return this.apiService.post(url, body, onResponse, onError);
  // }
}

export default CreateServiceUtil;
